import api from "./api";

export default class TermsApi {
  static async GetDetail(id) {
    return api.get(`terms/by-id/${id}`);
  }
}
